import { queryOptions, useQuery } from '@tanstack/react-query';

import { apiFetch } from '@/domains/general/api/client';

import type { SyncRun } from './types';

export const syncKeys = {
  all: ['sync'] as const,
  latest: () => [...syncKeys.all, 'latest'] as const,
} as const;

export const syncQueries = {
  latest: () =>
    queryOptions({
      queryKey: syncKeys.latest(),
      queryFn: (): Promise<SyncRun | null> => apiFetch<SyncRun | null>('/sync/latest'),
    }),
};

export function useLatestSyncRun() {
  return useQuery(syncQueries.latest());
}
